import { render, staticRenderFns } from "./NewDebate.vue?vue&type=template&id=24133cfd&scoped=true&"
import script from "./NewDebate.vue?vue&type=script&lang=js&"
export * from "./NewDebate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24133cfd",
  null
  
)

export default component.exports